import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-sms-notification',
    imports: [],
    templateUrl: './icon-sms-notification.html',
    styleUrl: './icon-sms-notification.css'
})
export class IconSmsNotification {
    @Input() size: string = '24px';
    @Input() color: string = '#000';
}
